module.exports = __webpack_public_path__ + "media/images/career_camp/2022/texts/step_by_step-2ff126f887c8da14bcfe2fda8e341d5a.svg";